module.exports = DDC.WsmCommonData;